import styled from 'styled-components'
import { device } from '@/common/constants/device'

export default styled.p`
  display: block;

  font-size: ${(props) => `${props.size}px` || '16px'};
  font-weight: ${(props) => props.weight || '400'};
  color: var(--${(props) => props.color || 'grey'});

  @media ${device.tablet} {
    font-size: ${({ sizeT }) => sizeT && `${sizeT}px`};
  }

  @media ${device.laptopL} {
    font-weight: ${({ weightL }) => weightL && weightL};
    font-size: ${({ sizeL }) => sizeL && `${sizeL}px`};
  }
`
